<div class="navbar-dropdown device-list-dropdown text-nowrap d-flex align-items-center" ngbDropdown display="dynamic">
  <button
    type="button"
    class="btn btn-link rounded-0 d-flex align-items-center gap-3"
    (click)="selectDevice.emit(device)"
    ngbTooltip="{{ deviceName(device) | async }}: {{ deviceCurrentState(device) | async | deviceStateMessage }}"
    placement="bottom"
    [openDelay]="450"
  >
    <i class="bi-circle-fill text-{{ deviceCurrentState(device) | async | deviceStateClass }}"></i>
    <span>{{ deviceName(device) | async | truncate: 16 : false }}</span>
  </button>

  <button class="btn btn-link dropdown-toggle-split rounded-0" ngbDropdownToggle></button>

  <div class="shadow p-0" ngbDropdownMenu>
    <div class="overflow-auto" style="max-height: 400px">
      @for (device of allDevices$ | async; track device.serialNumber) {
        <button
          type="button"
          class="dropdown-item d-flex align-items-center border-top gap-3 p-3"
          (click)="selectDevice.emit(device)"
        >
          <i
            class="device-list-dropdown__status-icon bi-circle-fill text-{{
              deviceCurrentState(device) | async | deviceStateClass
            }}"
          ></i>
          <div class="device-list-dropdown__device-graphic d-inline-block">
            <app-device-graphic [device]="device"></app-device-graphic>
          </div>
          <span>{{ deviceName(device) | async }}</span>
        </button>
      }
    </div>

    <div class="dropdown-divider my-0"></div>

    <button type="button" class="dropdown-item d-flex align-items-center gap-2 p-3" (click)="onViewDeviceLog(device)">
      <i class="bi-file-text-fill"></i>
      <span>View Device Log</span>
    </button>

    <button type="button" class="dropdown-item d-flex align-items-center gap-2 p-3" (click)="onViewSystemLog()">
      <i class="bi-file-text-fill"></i>
      <span>View System Log</span>
    </button>

    <div class="dropdown-divider my-0"></div>

    <button type="button" class="dropdown-item d-flex align-items-center gap-2 p-3" (click)="onSaveProblemReport()">
      <i class="bi-file-earmark-arrow-down-fill"></i>
      <span>Save problem report <code class="text-body-secondary">(.zip)</code></span>
    </button>

    <button
      type="button"
      class="dropdown-item d-flex align-items-center justify-content-between gap-3 p-3"
      (click)="onKeyboardShortcuts()"
    >
      <div class="d-flex align-items-center gap-2">
        <i class="bi-keyboard-fill"></i>
        <span>Show Keyboard Shortcuts</span>
      </div>
      <div>
        <kbd>?</kbd>
      </div>
    </button>

    <button type="button" class="dropdown-item d-flex align-items-center gap-2 p-3" (click)="backToDashboard.emit()">
      <i class="bi-arrow-left"></i>
      <span>Back to Dashboard</span>
    </button>
  </div>
</div>
